const mxn = new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN", maximumFractionDigits: 2 });
const int = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 0 });
const dec = new Intl.NumberFormat("es-MX", { maximumFractionDigits: 2 });

export const formatMXN = (n: number) => mxn.format(n);
export const formatInt = (n: number) => int.format(n);
export const formatNumber = (n: number) => dec.format(n);
export const formatPct = (ratio: number, digits = 1) => `${(ratio * 100).toFixed(digits)}%`;

const longDate = new Intl.DateTimeFormat("es-MX", { day: "numeric", month: "short", year: "numeric", timeZone: "UTC" });
/** Format a YYYY-MM-DD local business date for humans. */
export const formatDayHuman = (day: string) => longDate.format(new Date(`${day}T00:00:00Z`));

/** Round to 2 decimals (money / ratios computed in code). */
export const round2 = (n: number) => Math.round(n * 100) / 100;
